<template>
  <div class="c-bracelet-price-display">
    <div class="c-bracelet-price-display__bracelet-price-container">
      <product-price
        :price="modPrice"
        :compare-at-price="modCompareAtPrice"
      />
    </div>
  </div>
</template>

<script>
import ProductPrice from '@/components/productPrice/ProductPrice'

export default {
  name: "BraceletPriceDisplay",
  components: {
    ProductPrice
  },
  props: {
    modPrice: {
      type: String,
      required: true
    },
    modCompareAtPrice:{
      type: String,
      default: ''
    },
  },
}
</script>

<style  lang="scss" scoped>
.c-bracelet-price-display {

  &__bracelet-price-container {
    display:flex;
    position: absolute;
    z-index: $zindex-tooltip;
    top: 0;
    right: 0;
    height: 50px;
    min-width: rem(150px);
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    @include themify($themes) {
      background-color: themed('background', 'x-light');
    }
    padding: rem(10px);
    text-align: center;
  }
}

</style>
